import { isOpenFinRuntime } from '../../../containers/OpenFin/helpers'
import { useOpenFin } from '../../../helpers/hooks/useOpenFin'
import { getRfqQuoteRequestForSecurity } from '../../../store/rfq/selectors'
import { useAppDispatch, useAppSelector } from '../../../store/types'
import { setRfqActiveWindowIndex } from '../../../store/windows/actions'
import {
  getActiveRfqWindow,
  getRfqWindows
} from '../../../store/windows/selectors'
import RFQModal from '../RfqModal/RFQModal'

import styles from '../modal.module.scss'

const getNewActiveValue = (isMinimized: boolean, index: number) => {
  if (isMinimized) return index
}
const RfqModalStack = () => {
  const dispatch = useAppDispatch()
  const { openPlatformWindow } = useOpenFin()
  const modalWindows = useAppSelector(getRfqWindows)
  const activeModalIndex = useAppSelector(getActiveRfqWindow)
  const rfqInfoGetter = useAppSelector(getRfqQuoteRequestForSecurity)

  return (
    <div className={styles.rfqModalStack}>
      {modalWindows.map((windowInfo, i) => {
        const rfq = rfqInfoGetter(windowInfo.securityId)
        if (!rfq) return null
        const isMinimized = i !== activeModalIndex
        const newActiveValue = getNewActiveValue(isMinimized, i)
        const handleMinimize = () =>
          dispatch(setRfqActiveWindowIndex(newActiveValue))
        if (!rfq.requestId || !windowInfo.isOpen) return null
        if (isOpenFinRuntime()) {
          void openPlatformWindow(
            `RFQs/${windowInfo.orderId}/${rfq.securityId}`
          )
          return null
        } else {
          return (
            <RFQModal
              rfq={rfq}
              windowInfo={windowInfo}
              isMinimized={isMinimized}
              handleMinimize={handleMinimize}
              key={rfq.requestId}
            />
          )
        }
      })}
    </div>
  )
}

export default RfqModalStack
